import { render, staticRenderFns } from "./post-dialog.vue?vue&type=template&id=18d149db&scoped=true"
import script from "./post-dialog.vue?vue&type=script&lang=js"
export * from "./post-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d149db",
  null
  
)

export default component.exports